export const getUserMovieInteractionQuery = /* GraphQL */ `
  query GetUserMovieInteraction($userID: ID!, $movieID: ID!) {
    listUserMovieInteractions(
      filter: { 
        and: [
          { userID: { eq: $userID } }
          { movieID: { eq: $movieID } }
        ]
      }
    ) {
      items {
        id
        userID
        movieID
        watched
        notInterested
        inWatchlist
        isFavorite
        watchCount
        lastWatchedAt
        createdAt
        updatedAt
      }
    }
  }
`;

export const createUserMovieInteractionMutation = /* GraphQL */ `
  mutation CreateUserMovieInteraction($input: CreateUserMovieInteractionInput!) {
    createUserMovieInteraction(input: $input) {
      id
      userID
      movieID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      createdAt
      updatedAt
    }
  }
`;

export const updateUserMovieInteractionMutation = /* GraphQL */ `
  mutation UpdateUserMovieInteraction($input: UpdateUserMovieInteractionInput!) {
    updateUserMovieInteraction(input: $input) {
      id
      userID
      movieID
      watched
      notInterested
      inWatchlist
      isFavorite
      watchCount
      lastWatchedAt
      createdAt
      updatedAt
    }
  }
`;